export default "__VITE_ASSET__d54e638a__"